import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Menu,
    MenuItem,
    IconButton,
    TablePagination,
    Grid,
    Box,
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import './ClientList.css'; // Import the CSS file
import AddButton from '../../Common_Components/AddButton';
import { useNavigate } from 'react-router-dom';
import { Delete, Edit, Visibility } from '@mui/icons-material';
import { MdHistory, MdMoreHoriz } from 'react-icons/md';
import FilterModal from '../../Common_Components/FilterModal';
import axiosInstance from '../../axios/axios';
import ClientViewModal from './ClientViewModal';
import { hasPrivilege } from '../UserRole/PrevilegeCheck';
import ConfirmDeleteModal from './ConfirmDeleteModal';
import { Toast } from '../../Common_Components/Toast';
import CustomInputField from '../../Common_Components/CustomInputField';
import CustomSelectBox from '../../Common_Components/CustomSelectBox';
import SaveButton from '../../Common_Components/SaveButton';
import ResetButton from '../../Common_Components/ResetButton';
const style = {
    fontFamily: 'Times New Roman',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '18.4px',
    color: '#000000',
    alignItems: 'center'
}
const ViewStyle = {
    color: '#72E463', // Customize the color of the text
    fontFamily: 'Josefin Sans, sans-serif', // Set the font family
    fontWeight: 400, // Set font weight
    textAlign: 'center', // Center text
    padding: '12px 12px', // Custom padding
    '& .MuiSvgIcon-root': {
        color: '#72E463', // Customize the color of the icon
    },
}
const editStyle = {
    color: '#FFC575', // Customize the color of the text
    fontFamily: 'Josefin Sans, sans-serif', // Set the font family
    fontWeight: 400, // Set font weight
    textAlign: 'center', // Center text
    padding: '12px 12px', // Custom padding
    '& .MuiSvgIcon-root': {
        color: '#FFC575', // Customize the color of the icon
    },
}

const deleteStyle = {
    color: '#FF7575', // Customize the color of the text
    fontFamily: 'Josefin Sans, sans-serif', // Set the font family
    fontWeight: 400, // Set font weight
    textAlign: 'center', // Center text 
    padding: '12px 12px', // Custom padding
    '& .MuiSvgIcon-root': {
        color: '#FF7575', // Customize the color of the icon
    },
}

const historyStyle = {
    color: '#5C3685', // Customize the color of the text
    fontFamily: 'Josefin Sans, sans-serif', // Set the font family
    fontWeight: 400, // Set font weight
    textAlign: 'center', // Center text
    padding: '12px 12px', // Custom padding
    '& .MuiSvgIcon-root': {
        color: '#5C3685', // Customize the color of the icon
    },
}
const ClientList = () => {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleCloseModal = () => setOpen(false);
    const [open_viewclient, setopen_viewclient] = useState(false)
    const handleOpenviewclient = () => setopen_viewclient(true);
    const handleCloseviewClientModal = () => setopen_viewclient(false);
    const [clientLists, setClientLists] = useState([])
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
    const statusList = [{ id: 1, label: "Active" }, { id: 0, label: "Inactive" }]
    const [status, setStatus] = useState(null)
    const [clientname, setClientName] = useState('')
    const [clientaddress, setClientaddress] = useState('')
    const [clientpoc, setclientPoc] = useState('')
    const [clientphone, setClientPhone] = useState('')
    const [render, setRender] = useState(0)
    const getClientList = async () => {
        const response = await axiosInstance.post('/clients/clientList')
        const { success, clients } = response.data
        if (success === true) {
            setClientLists(clients)
        } else {
            setClientLists([])
        }
    }
    useEffect(() => {

        getClientList()
    }, [render])

    const handleClick = (event, product) => {
        setAnchorEl(event.currentTarget);
        setSelectedProduct(product); // Store the selected product
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleView = () => {
        // console.log("View:", selectedProduct);
        handleOpenviewclient()
        handleClose();
    };

    const handleEdit = (value) => {
        // console.log("Edit:", selectedProduct);
        navigate(`/client-add/${selectedProduct?.CD_Id}`)
        handleClose();
    };

    // const handleDelete = () => {
    //     // console.log("Delete:", selectedProduct);
    //     handleClose();
    // };
    const handleHistory = () => {
        navigate(`/client-license-history/${selectedProduct?.CD_Id}`, { state: { clientName: selectedProduct.CD_Name } })
        handleClose();
    }
    const handlenavigatetoAdd = async () => {
        navigate('/client-add')
    }
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleDelete = async () => {
        setOpenConfirmDelete(true);  // Open the confirmation modal
        handleClose();
    };

    const handleConfirmDelete = async () => {
        try {
            const response = await axiosInstance.post(`/clients/delete/${selectedProduct?.CD_Id}`);
            if (response.data.success) {
                setRender(render + 1)
                Toast.success(response.data.message);
                setOpenConfirmDelete(false);
                // Optionally, refresh the list or remove the client from the state
            } else {
                Toast.error(response.data.error);
                setOpenConfirmDelete(false);
            }
        } catch (error) {
            console.error('Error deleting client:', error);
        }
    };
    const handleCloseConfirmDelete = () => {
        setOpenConfirmDelete(false);
    };
    const fetchProductFilter = async () => {
        const filtersreq = {
            status: status?.id,
            clientName: clientname,
            address: clientaddress,
            mobile: clientphone,
            pointOfContact: clientpoc,
        }
        const response = await axiosInstance.post('/clients/clientList', filtersreq)
        const { success, clients } = response.data
        if (success === true) {
            setClientLists(clients)
        } else {
            setClientLists([])
        }
    }

    const handleSearch = () => {
        fetchProductFilter();
    }
    const handleReset = () => {
        setClientName('')
        setClientaddress('')
        setclientPoc('')
        setClientPhone('')
        setStatus(null)
        getClientList();
    };
    return (
        <div className="product-list">
            <ConfirmDeleteModal
                open={openConfirmDelete}
                onClose={handleCloseConfirmDelete}
                onConfirm={handleConfirmDelete}
            />
            <ClientViewModal open={open_viewclient} handleClose={handleCloseviewClientModal} clientId={selectedProduct?.CD_Id} />
            <FilterModal open={open} handleClose={handleCloseModal} />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h2 className='producttitle'>Clients</h2>
                <div style={{ display: 'flex', alignItems: 'center' }}>

                    {
                        hasPrivilege('Add Client') && <AddButton onClick={handlenavigatetoAdd} />}
                </div>
            </div>
            <Grid container spacing={2} mb={3}>
                <Grid item xs={12} md={2}>
                    <CustomInputField
                        label="Client Name"
                        value={clientname}
                        onChange={(e) => setClientName(e.target.value)}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={2}>
                    <CustomInputField
                        label="Client Address"
                        value={clientaddress}
                        onChange={(e) => setClientaddress(e.target.value)}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={2}>
                    <CustomInputField
                        label="Client POC"
                        value={clientpoc}
                        onChange={(e) => setclientPoc(e.target.value)}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={2}>
                    <CustomInputField
                        label="Phone Number"
                        value={clientphone}
                        onChange={(e) => setClientPhone(e.target.value)}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={2}>
                    <CustomSelectBox
                        label="Status"
                        options={statusList}
                        Value={status}
                        setValue={setStatus}
                        fullWidth
                    />
                </Grid>
                <Grid
                    container
                    item
                    xs={12}
                    md={2}
                    sx={{ mt: 4 }}
                    alignItems="center"
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "left", // Controls button placement
                            gap: 2, // Minimal gap between buttons
                            width: "100%",
                        }}
                    >
                        <SaveButton label="Search" onClick={handleSearch} fullWidth={false} />
                        <ResetButton label="Reset" onClick={handleReset} fullWidth={false} />
                    </Box>
                </Grid>
            </Grid>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead style={{ backgroundColor: '#EEDEFF' }}>
                        <TableRow>
                            <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 700, fontSize: '16px', lineHeight: '18.4px', color: '#302D2D' }}>Sl no</TableCell>
                            <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 700, fontSize: '16px', lineHeight: '18.4px', color: '#302D2D' }}>Client Name</TableCell>
                            <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 700, fontSize: '16px', lineHeight: '18.4px', color: '#302D2D' }}>Address</TableCell>
                            <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 700, fontSize: '16px', lineHeight: '18.4px', color: '#302D2D' }}>Country</TableCell>
                            <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 700, fontSize: '16px', lineHeight: '18.4px', color: '#302D2D' }}>State</TableCell>
                            <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 700, fontSize: '16px', lineHeight: '18.4px', color: '#302D2D' }}>Point of Contact</TableCell>
                            <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 700, fontSize: '16px', lineHeight: '18.4px', color: '#302D2D' }}>Mobile Phone</TableCell>
                            <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 700, fontSize: '16px', lineHeight: '18.4px', color: '#302D2D' }}>Email ID</TableCell>
                            <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 700, fontSize: '16px', lineHeight: '18.4px', color: '#302D2D' }}>Billing Address</TableCell>
                            <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 700, fontSize: '16px', lineHeight: '18.4px', color: '#302D2D' }}>Status</TableCell>
                            <TableCell sx={{ fontFamily: 'Times New Roman', fontWeight: 700, fontSize: '16px', lineHeight: '18.4px', color: '#302D2D' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {clientLists && clientLists.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((product, index) => (
                                <TableRow key={product.CD_Id} style={{ backgroundColor: index % 2 === 0 ? '#F6F6F6' : '#DAD9D9' }}>
                                    <TableCell sx={style}>{index + 1}</TableCell>
                                    <TableCell sx={style}>{product.CD_Name}</TableCell>
                                    <TableCell sx={style}>{product.CD_Address}</TableCell>
                                    <TableCell sx={style}>{product.country_name}</TableCell>
                                    <TableCell sx={style}>{product.city_name}</TableCell>
                                    <TableCell sx={style}>{product.CD_POC}</TableCell>
                                    <TableCell sx={style}>{product.CD_Phone}</TableCell>
                                    <TableCell sx={style}>{product.CD_Email}</TableCell>
                                    <TableCell sx={style}>{product.CD_BillingAddress}</TableCell>
                                    <TableCell sx={style}>{Number(product.CD_Status) === 1 ? "Active" : "Inactive"}</TableCell>
                                    <TableCell>
                                        <MdMoreHoriz size={30} onClick={(event) => handleClick(event, product)} />
                                        <Menu
                                            id="action-menu"
                                            anchorEl={anchorEl}
                                            open={Boolean(anchorEl)}
                                            onClose={handleClose}
                                            sx={{
                                                width: '293px',
                                                '& .MuiMenuItem-root': {
                                                    minWidth: '200px', // Increase the size of each menu item
                                                    borderBottom: '1px solid #e0e0e0', // Underline after each item
                                                    '&:last-child': {
                                                        borderBottom: 'none', // Remove underline from the last item
                                                    },
                                                },
                                            }}
                                        >
                                            {
                                                hasPrivilege('Add Client') && <MenuItem
                                                    onClick={handleView}
                                                    sx={ViewStyle}
                                                >
                                                    <Visibility sx={{ mr: 1 }} />
                                                    View
                                                </MenuItem>
                                            }
                                            {
                                                hasPrivilege('Edit Client') && <MenuItem
                                                    onClick={(e) => handleEdit(product)}
                                                    sx={editStyle}
                                                >
                                                    <Edit sx={{ mr: 1 }} />
                                                    Edit
                                                </MenuItem>
                                            }
                                            {
                                                hasPrivilege('Delete Client') && <MenuItem onClick={handleDelete} sx={deleteStyle}>
                                                    <Delete sx={{ mr: 1 }} />
                                                    Delete
                                                </MenuItem>
                                            }
                                            {
                                                hasPrivilege('Client History') && <MenuItem onClick={handleHistory} sx={historyStyle}>
                                                    <MdHistory size={'25'} style={{ marginRight: 7 }} /> History
                                                </MenuItem>
                                            }
                                        </Menu>
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={clientLists.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </TableContainer>
        </div>
    )
}

export default ClientList